import { defineComponent as _defineComponent } from 'vue'
import { useTranslations } from "@/hooks/useTranslations";


export default /*#__PURE__*/_defineComponent({
  __name: 'vUnroundedValuesWarning',
  setup(__props) {

const translations = useTranslations('recipes');

return { __sfc: true,translations }
}

})